<template>
	<div class="common-layout">
		<el-container>
			<el-header>
				<Header ref="ComponentsHeader"/>
			</el-header>
			<el-container>
				<el-aside class="Nav">
					<Navbar />
				</el-aside>
				<el-main class="Main">
					<router-view v-slot="{ Component }">
						<transition name="fade-transform" mode="out-in">
							<component :is="Component" ref="ComponentsMain" @onSystemElement="GetSystemElement"/>
						</transition>
					</router-view>
				</el-main>
			</el-container>
		</el-container>
	</div>
</template>

<style lang="scss" scoped>
	@import "./index.scss";
</style>

<script>
  import index from "./index-Js";
  export default index;
</script>



